import React from 'react';

interface RevenueRow {
  id: string;
  sessionId: string;
  amountUsdCents: number;
  rail: string;
  recordedAt: number;
}

interface RevenueListProps {
  rows: RevenueRow[];
}

export const RevenueList: React.FC<RevenueListProps> = ({ rows }) => {
  if (!rows.length) {
    return (
      <div className='text-sm text-center py-6' style={{ color: 'var(--pp-text-subtle)' }}>
        No revenue records
      </div>
    );
  }

  return (
    <div className='flex flex-col divide-y' style={{ borderColor: 'var(--pp-border)' }}>
      {rows.slice(0, 8).map((r) => (
        <div key={r.id} className='flex items-center justify-between py-2.5'>
          <div className='flex flex-col'>
            <span style={{ fontFamily: 'var(--pp-mono)', fontSize: '0.72rem', color: 'var(--pp-text-muted)' }}>
              {r.sessionId.slice(0, 14)}…
            </span>
            <span className='text-xs uppercase' style={{ color: 'var(--pp-text-subtle)' }}>
              {r.rail}
            </span>
          </div>
          <div className='flex flex-col items-end'>
            <span style={{ fontFamily: 'var(--pp-mono)', fontWeight: 600, color: 'var(--pp-settled)' }}>
              +${(r.amountUsdCents / 100).toFixed(2)}
            </span>
            <span style={{ fontFamily: 'var(--pp-mono)', fontSize: '0.7rem', color: 'var(--pp-text-subtle)' }}>
              {new Date(r.recordedAt * 1000).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}
            </span>
          </div>
        </div>
      ))}
    </div>
  );
};

export default RevenueList;
